"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _payuIcons = _interopRequireDefault(require("../../../assets/fonts/payu-icons.eot"));

var _payuIcons2 = _interopRequireDefault(require("../../../assets/fonts/payu-icons.ttf"));

var _payuIcons3 = _interopRequireDefault(require("../../../assets/fonts/payu-icons.woff"));

var _payuIcons4 = _interopRequireDefault(require("../../../assets/fonts/payu-icons.svg"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var FontFaces = {
  fontFamily: "payuicons",
  src: ["url(".concat(_payuIcons["default"], ")"), "url(\"".concat(_payuIcons["default"], "?p8tzta#iefix\") format(\"embedded-opentype\"),\n    url(\"").concat(_payuIcons2["default"], "?p8tzta\") format(\"truetype\"),\n    url(\"").concat(_payuIcons3["default"], "?p8tzta\") format(\"woff\"),\n    url(\"").concat(_payuIcons4["default"], "?p8tzta#icomoon\") format(\"svg\")")],
  fontWeight: "normal",
  fontStyle: "normal",
  fontDisplay: "block"
};
var _default = FontFaces;
exports["default"] = _default;